import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nService } from '@nomoh-monorepo/data-access-shared-i18n';
import { Language } from '@nomoh-monorepo/shared-types';

// Import do PrimeNG
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'lib-language-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  private i18nService = inject(I18nService);

  // Consome os dados diretamente do serviço existente
  languages = this.i18nService.supportedLanguages;
  $currentLanguage = this.i18nService.idioma;

  // Output para notificar quando idioma é selecionado
  languageSelected = output<Language>();

  onLanguageChange(language: Language): void {
    if (language.code) {
      this.i18nService.setLanguage(language.code, true);
      this.languageSelected.emit(language);
    }
  }
}
